export default __webpack_public_path__ + "static/media/arrow_right.2796f802.svg";